export default {
  common: 'common',
  glassWallDoorProperties: 'glassWallDoorProperties',
  glassWallGlassProperties: 'glassWallGlassProperties',
  glassWallProperties: 'glassWallProperties',
  woodyWallProperties: 'woodyWallProperties',
  leftBar: 'leftBar',
};
